export default function validateCreateLink(values) {
  let errors = {};

  // Description Errors
  if (!values.description) {
    errors.description = 'Beschreibung erforderlich';
  } else if (values.description.length < 10) {
    errors.description = 'Die Beschreibung muss mindestens 10 Zeichen lang sein';
  }
  // Url Errors
  if (!values.url) {
    errors.url = 'URL erforderlich';
  } else if (!/^(ftp|http|https):\/\/[^ "]+$/.test(values.url)) {
    errors.url = 'URL muss gültig sein';
  }

  return errors;
}
